module.exports = __webpack_public_path__ + "static/media/hector.f5eb67bd.jpg";